import resolveOrganizationAccess, {
  type OrganizationAccessRequirement,
  type OrganizationAccessState
} from '@/shared/components/organization/organizationAccess';
import { useOrganizationAccessContextValue } from '@/shared/components/organization/useOrganizationAccessContextValue';

/**
 * Resolves the access state for the organization provided by the nearest
 * {@link OrganizationAccessProvider} against the given requirement.
 *
 * This is a pure, synchronous read of the precomputed context value — it fires no
 * requests and performs no traversal, so it is cheap to call from many
 * sections/buttons on the same screen.
 *
 * @example
 * const access = useOrganizationAccess({ roles: [ADMIN] });
 * if (access === 'granted') return <EditButton />;
 */
export const useOrganizationAccess = (
  requirement?: OrganizationAccessRequirement
): OrganizationAccessState => {
  const contextValue = useOrganizationAccessContextValue();
  return resolveOrganizationAccess(contextValue, requirement);
};
